import { useQuery } from "@tanstack/react-query";
import { queryList } from "../../utils";
import { approvalDecisionsByTransactionId } from "../../graphql/queries";
import {
  ApprovalDecision,
  ApprovalDecisionsByTransactionIdQuery,
  ApprovalDecisionsByTransactionIdQueryVariables,
} from "../../API";
import { approvalKeys } from "./query-keys";

export const useApprovalDecisions = (transactionId: string | undefined) =>
  useQuery({
    queryKey: approvalKeys.decisions(transactionId),
    queryFn: () =>
      queryList<
        ApprovalDecision,
        ApprovalDecisionsByTransactionIdQueryVariables,
        ApprovalDecisionsByTransactionIdQuery
      >(approvalDecisionsByTransactionId, {
        transactionId: transactionId!,
      }),
    enabled: !!transactionId,
  });
